import React from 'react'

const regex = /(\n)/g

/** テキスト内改行 `\n` を 改行タグ `<br />` に変換 */
export const nl2Br = (text: string) =>
  text
    .split(regex)
    .map((line, i) => (line.match(regex) ? <br key={i} /> : line))
